module.exports = __webpack_public_path__ + "img/02-051-jm-flow-1.657a5dcc.png";